import { IntervalChartSettings } from '@mono/types/src/interval-chart';

export const defaultIntervalChartSettings: IntervalChartSettings = {
    title: 'Title',
    leftOffset: 50,
    fontSize: 100,
    yAxisLabel: 'Y Axis Label',
    unit: '',
    unitLabel: '',
    intervalType: 'area',
    thresholds: [],
    showHighestThreshold: false,
    interval: 3,
    radius: 10e3,
    databilities: [
        {
            id: 'mean',
            datasetId: null,
            capabilityId: null,
            timeRange: 'P0D--P3D',
            space: {
                coordinates: [149.3144, -21.2625],
                type: 'Point',
            },
        },
        {
            id: 'upper',
            datasetId: '',
            capabilityId: '',
            timeRange: 'P0D--P3D',
            space: {
                coordinates: [149.3144, -21.2625],
                type: 'Point',
            },
        },
        {
            id: 'lower',
            datasetId: '',
            capabilityId: '',
            timeRange: 'P0D--P3D',
            space: {
                coordinates: [149.3144, -21.2625],
                type: 'Point',
            },
        },
        {
            id: 'high',
            datasetId: '',
            capabilityId: '',
            timeRange: 'P0D--P3D',
            space: {
                coordinates: [149.3144, -21.2625],
                type: 'Point',
            },
        },
        {
            id: 'low',
            datasetId: '',
            capabilityId: '',
            timeRange: 'P0D--P3D',
            space: {
                coordinates: [149.3144, -21.2625],
                type: 'Point',
            },
        },
        {
            id: 'directional',
            datasetId: '',
            capabilityId: '',
            timeRange: 'P0D--P3D',
            space: {
                coordinates: [149.3144, -21.2625],
                type: 'Point',
            },
        },
    ],
    mean: { databilityId: 'mean', label: 'Mean' },
    high: { databilityId: 'high', label: 'High' },
    low: { databilityId: 'low', label: 'Low' },
    direction: { databilityId: 'direction', label: 'Direction' },
    timezone: undefined,

    // highCapabilityId: 'wsp_10m_pdf_99perc',
    // lowCapabilityId: '',
    // lowerCICapabilityId: 'wsp_10m_pdf_10perc',
    // meanCapabilityId: 'wsp_10m_pdf_mean',
    // upperCICapabilityId: 'wsp_10m_pdf_90perc',
    // meanColour: 'green',
    // highColour: 'red',
    // lowColour: '#000000',
    // meanLabel: 'Mean',
    // highLabel: 'High',
    // lowLabel: 'Low',
};
